
import _ from 'lodash';

export default {
  name: 'AppDropdownMenu',
  model: { event: 'change' },
  props: {
    value: { type: [String, Number, Boolean, Array], default: null },
    options: { type: Array, required: true },
    type: {
      type: String,
      required: true,
      validator: v =>
        [
          'basic',
          'radio',
          'button',
          'button_multiple',
          'button_multiple_range',
          'score'
        ].includes(v)
    },
    title: { type: String, default: null },
    starColor: { type: String, default: null },
    starSize: { type: Number, default: 14 },
    fontLarge: { type: Boolean, default: false },
    showTitleSection: { type: Boolean, default: false },
    description: { type: String, default: '' },
    maxHeight: { type: Number, default: null }
  },
  data() {
    return {
      currentValue: Array.isArray(this.value)
        ? _.cloneDeep(this.value)
        : [this.value].filter(v => v)
    };
  },
  computed: {
    finalValue: {
      get() {
        return this.isMultipleSelect ? this.currentValue : this.currentValue[0];
      },
      set(newValue) {
        this.changeValue(newValue);
      }
    },
    showConfirm() {
      return [
        'button_multiple',
        'button_multiple_range',
        'button',
        'score'
      ].includes(this.type);
    },
    defaultOption() {
      return this.options.find(o => o.default);
    },
    isScoreType() {
      return this.type === 'score';
    },
    isRadioType() {
      return this.type === 'radio';
    },
    isButtonType() {
      return ['button_multiple', 'button_multiple_range', 'button'].includes(
        this.type
      );
    },
    isButtonMultipleRangeType() {
      return this.type === 'button_multiple_range';
    },
    isMultipleSelect() {
      return ['button_multiple', 'button_multiple_range', 'score'].includes(
        this.type
      );
    },
    maxHeightProps() {
      let maxHeight = this.maxHeight || 480;
      const headHeight = 52;
      const footHeight = 79;
      const padding = 15;

      maxHeight -= padding;
      if (this.showTitleSection) maxHeight -= headHeight;
      if (this.showConfirm) maxHeight -= footHeight;

      return {
        '--max-height': `${maxHeight}px`
      };
    }
  },
  mounted() {
    if (this.showTitleSection && !this.title) {
      throw new Error("'title' prop is mandatory");
    }
  },
  methods: {
    reset() {
      const defaultValue = this.defaultOption?.value || null;
      this.changeValue(defaultValue);
    },
    onConfirm() {
      this.apply();
    },
    apply() {
      if (!_.isEqual(this.value || [], this.finalValue)) {
        this.$emit('change', this.finalValue);
      }
      this.$emit('close');
    },
    clickOption(option) {
      if (option.disabled) return;

      this.changeValue(option.value);
    },
    toggleValue(value) {
      if (!value) {
        this.currentValue = [];
      } else if (this.currentValue.includes(value)) {
        this.currentValue = this.currentValue.filter(v => v !== value);
      } else {
        this.isMultipleSelect
          ? this.currentValue.push(value)
          : (this.currentValue = [value]);
      }
    },
    selectRangeValues(value) {
      if (!value) return (this.currentValue = []);

      if (this.currentValue.length === 1) {
        const currentItem = this.currentValue[0];
        if (currentItem === value) return this.toggleValue(value);

        const currentItemIndex = this.options.findIndex(
          e => e.value === currentItem
        );
        const selectedtItemIndex = this.options.findIndex(
          e => e.value === value
        );
        const min = Math.min(currentItemIndex, selectedtItemIndex);
        const max = Math.max(currentItemIndex, selectedtItemIndex) + 1;

        this.currentValue = this.options.slice(min, max).map(e => e.value);
      } else {
        this.currentValue = [value];
      }
    },
    changeValue(value) {
      if (this.isButtonMultipleRangeType) {
        this.selectRangeValues(value);
      } else if (this.isMultipleSelect || this.isButtonType) {
        this.toggleValue(value);
      } else {
        this.currentValue = [value];
      }

      if (!this.showConfirm) this.apply();
    },
    isSelected(option) {
      return this.currentValue.includes(option.value);
    }
  }
};
